import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { MachineService } from '../proxy/general/controllers/machine.service';
import { ForwarderCapacity } from '@general/forwarder-capacity/forwarder-capacity';
import { MachineClawChangeHistoric } from '@general/machine-claw-change-historic/machine-claw-change-historic';

FieldBuilder.setNamespace('General');

export const FORWARDER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('machineId', 'Entity.Machine', MachineService)
    .required()
    .displayFromNested('machine.name')
    .sortBy('machine.name')
    .build(),
];

export const FORWARDER_CONFIG = {
  entityName: 'Forwarder',
  localizationKey: 'General::Entity.Forwarder',
  fields: FORWARDER_FIELDS,
  permission: 'GeneralMachinesAndVehicles.Forwarders',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
  children: [
      {
        entityName: 'ForwarderCapacity',
        foreignKeyField: 'forwarderId',
        localizationKey: 'General::Entity.ForwarderCapacity',
        component: ForwarderCapacity,
      },
      {
        entityName: 'MachineClawChangeHistoric',
        foreignKeyField: 'machineId',
        localizationKey: 'General::Entity.MachineClawChangeHistoric',
        component: MachineClawChangeHistoric,
      },
    ]
};
